import axios from 'axios';
import store from "@/store/index";

// Generate a random GUID
const generateSessionGUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

const generateTransactionGUID = () => {
    return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

let sessionId = sessionStorage.getItem('session-id') || generateSessionGUID();
sessionStorage.setItem('session-id', sessionId);

const channelId = 'Pets.Web.QuoteFunnel';

const axiosInstance = axios.create({
    baseURL: `${window.location.origin}/api/`,
    headers: {
        'channel-id': channelId,
    },
    params: {}
});

axiosInstance.interceptors.request.use(
    (config) => {
        const project = store?.state?.project;
        
        if(project === 'artemis') {
            config.params = config.params || {};
            config.params.project = '2';
        }

        config.headers['session-id'] = sessionId;
        config.headers['transaction-id'] = generateTransactionGUID();

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        const sessionIdHeader = response.headers['session-id'];
        if (sessionIdHeader) {
            sessionId = sessionIdHeader;
            sessionStorage.setItem('session-id', sessionId);
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;